<template>
  <div class="search-location-wrapper">
    <div class="border border-main mb-5 search-location">
      <h4>{{ props.searchLocation.title }}</h4>
      <div
        class="col-10 mx-auto d-flex flex-column flex-lg-row justify-content-center align-items-lg-center search-location-input mt-4"
      >
        <p class="search-location-title text-center">
          {{ props.searchLocation.searchTitle }}
        </p>
        <Input
          :shouldHaveSearch="true"
          :shouldHaveSearchButton="true"
          :shouldHaveSearchClear="true"
          v-model="state.search"
          @placeChanged="handlePlaceChanged"
          @onClear="handleClear"
          :autocomplete="true"
          :placeholder="searchLocation.input.placeholder"
          :autocompleteOptions="state.autocompleteOptions"
        />
      </div>
    </div>
    <div class="result-section" :class="{ 'd-none': !state.showMap }">
      <ContactDetailsMap
        :contactDetails="props.searchLocation.contactDetails"
        :requestUrl="state.mapRequestUrl"
        :requestOnMount="false"
      />
    </div>
  </div>
</template>

<script setup>
import ContactDetailsMap from "@/components/сontact-details-map/ContactDetailsMap";
import api from "@/config/api";
import { reactive } from "vue";
import Input from "@/components/common/Input";
import { autocompleteOptions } from "@/config/config";

const props = defineProps({
  searchLocation: {
    title: String,
    searchTitle: String,
    input: {
      placeholder: String,
    },
    button: {
      text: String,
    },
    contactDetails: {
      disableHeader: Boolean,
      title: String,
      description: HTMLElement,
      locationIcon: String,
      label: String,
      button: {
        text: String,
        link: String,
      },
      iconsDescription: {
        screwDriver: String,
        service: String,
      },
      mapPlaceholderImage: String,
      map: {
        zoom: Number,
      },
    },
  },
});

const state = reactive({
  search: "",
  autocompleteOptions,
  showMap: false,
  mapRequestUrl: "",
});

const handlePlaceChanged = async (location) => {
  state.mapRequestUrl = `${api.closestLocation}?city=${location.city}&latitude=${location.latitude}&longitude=${location.longitude}`;
  state.showMap = true;
};
</script>
